import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface MessageThinkingIndicatorProps {
  label?: string;
  className?: string;
}

/**
 * Fading "Thinking..." label shown while the assistant is working. The newer
 * chat surfaces use this in place of the bouncing-dots
 * `MessageTypingIndicator`.
 */
export const MessageThinkingIndicator: FC<MessageThinkingIndicatorProps> = ({
  label = "Thinking...",
  className,
}) => (
  <div
    role="status"
    aria-label="The assistant is thinking"
    className={twMerge("flex h-6 items-center", className)}
  >
    <span className="animate-pulse text-xs font-medium text-muted-foreground">
      {label}
    </span>
  </div>
);
